<div class="module-wrapper">
    <div class="module drop-shadow bottom">
        <table class="std-table stacked-sm">
            <thead>
            <th>Bulk tag</th>
            <th>Interaction type</th>
            <th>Requested</th>
            <th>Scheduled</th>
            <th>Total requests</th>
            <th>Failed</th>
            <th>In progress</th>
            <th>Complete</th>
            <th></th></thead>
            <tbody>
                <tr *ngFor="let item of bulkInteractions">
                    <td data-label="Bulk tag"><span class="h-uppercase h-bold">{{item.bulkID}}</span></td>
                    <td data-label="Interaction type">{{item.requestName}}</td>
                    <td data-label="Requested">{{item.requestDate | date:'dd/MM/yyyy, H:mm'}}</td>
                    <td data-label="Scheduled">{{item.scheduleTime ? (item.scheduleTime | date:'dd/MM/yyyy, H:mm') : ''}}</td>
                    <td data-label="Total requests">{{item.count}}</td>
                    <td data-label="Failed">{{item.errorCount}}</td>
                    <td data-label="In progress">{{item.progressCount}}</td>
                    <td data-label="Complete">{{item.completedCount}}</td>
                    <td class="text-right">
                        <a style="cursor:pointer" class="text-link focus-element danger" (click)="cancelInteraction(item)">
                            <span *ngIf="!item.isCompleted && item.isMyInteraction" class="focus--content" tabindex="-1">Cancel</span>
                        </a>
                        <a (click)="clickItem(item)" class="text-link focus-element" style="cursor:pointer"><span class="focus--content" tabindex="-1">View</span></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
